export default __webpack_public_path__ + "static/media/scorecard-icon.9fef44c3.svg";